import { render, staticRenderFns } from "./ImageEffectsProperties.vue?vue&type=template&id=d0b57998&scoped=true"
import script from "./ImageEffectsProperties.vue?vue&type=script&setup=true&lang=ts"
export * from "./ImageEffectsProperties.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ImageEffectsProperties.vue?vue&type=style&index=0&id=d0b57998&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0b57998",
  null
  
)

export default component.exports